// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"RD-z","smallCardRow":"SD-z","largeCardRow":"TD-z","productSearchRow":"UD-z","curatedRow":"VD-z"};